export const CAROUSEL_HEIGHT = 'calc(100vh - 15.625rem)';
export const IMAGE_HEIGHT = 'calc(100vh - 13.3125rem)';

export const THUMB_SIZE = 96;
